import React from 'react';

import Select from 'react-select';

const customStyles = {
    control: styles => ({
        ...styles,
        // This line disable the blue border
        boxShadow: "0 !important",
        borderColor: "lightgray",
        "&:hover": {
            borderColor: "gray"
        }
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        backgroundColor: 'lightgray',
        "&:hover": {
            color: 'white',
            backgroundColor: 'lightgray',
        }
    }),
    // Keep the open menu above sibling cards / icons when rendered via menuPortalTarget.
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
}


export default (props) => (
    <Select
        styles={customStyles}
        {...props}
    />
);